export const formatIsoDate = (iso) => {
    if (!iso) return "—";
    const str = String(iso);
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
    if (match) {
        const [, year, month, day] = match;
        return `${day}.${month}.${year}`;
    }
    try {
        return new Date(str).toLocaleDateString("de-DE");
    } catch (error) {
        return str;
    }
};

export const formatPlanPrice = (amount, yearly) => {
    if (amount == null) {
        return "";
    }
    const numeric = Number(amount);
    const formatted = Number.isFinite(numeric)
        ? new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(numeric)
        : String(amount);
    return yearly ? `${formatted} pro Jahr` : `${formatted} pro Monat`;
};
